import { hasSlotContent as e } from "../../common/utils/index.js";
import t from "../text/text.js";
import n from "../stack/stack.js";
import { EMPTY_STATE_BODY_DENSITIES as r, EMPTY_STATE_BODY_SIZES as i, EMPTY_STATE_CONTENT_SIZE_MODIFIERS as a, EMPTY_STATE_HEADLINE_DENSITIES as o, EMPTY_STATE_HEADLINE_SIZES as s, EMPTY_STATE_SIZE_MODIFIERS as c } from "./empty-state-constants.js";
import { computed as l, createBlock as u, createCommentVNode as d, createElementBlock as f, createTextVNode as p, createVNode as m, normalizeClass as h, onMounted as g, openBlock as _, renderSlot as v, toDisplayString as y, unref as b, useSlots as x, withCtx as S } from "vue";
//#region components/empty_state/empty_state.vue
var C = /* @__PURE__ */ Object.assign({ name: "DtEmptyState" }, {
	__name: "empty_state",
	props: {
		size: {
			type: [String, Number],
			default: 400,
			validator: (e) => Object.keys(c).includes(String(e))
		},
		headerText: {
			type: String,
			required: !0
		},
		bodyText: {
			type: String,
			default: null
		},
		illustrationClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		iconClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		bodyClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		}
	},
	setup(C) {
		let w = x(), T = C, E = l(() => e(w.icon)), D = l(() => e(w.illustration)), O = l(() => E.value && (!D.value || j.value)), k = l(() => D.value && !j.value), A = l(() => String(T.size)), j = l(() => A.value === "sm" || A.value === "200"), M = l(() => c[A.value]), N = l(() => ["d-empty-state", M.value]), P = l(() => a[A.value]), F = l(() => s[A.value]), I = l(() => o[A.value]), L = l(() => i[A.value]), R = l(() => r[A.value]);
		return g(() => {
			!T.bodyText && !e(w.body) && console.error("DtEmptyState: You should provide either bodyText or content on body slot.");
		}), (r, i) => (_(), u(b(n), { class: h(N.value) }, {
			default: S(() => [
				k.value ? (_(), f("span", {
					key: 0,
					class: h(["d-empty-state__illustration", C.illustrationClass])
				}, [v(r.$slots, "illustration")], 2)) : d("", !0),
				O.value ? (_(), f("span", {
					key: 1,
					class: h(["d-empty-state__icon", C.iconClass])
				}, [v(r.$slots, "icon", { iconSize: "800" })], 2)) : d("", !0),
				m(b(n), {
					gap: "150",
					class: h(["d-empty-state__content", P.value])
				}, {
					default: S(() => [m(b(t), {
						kind: "headline",
						size: F.value,
						density: I.value,
						wrap: "balance",
						as: "div",
						class: "d-empty-state__header-text"
					}, {
						default: S(() => [p(y(C.headerText), 1)]),
						_: 1
					}, 8, ["size", "density"]), C.bodyText ? (_(), u(b(t), {
						key: 0,
						kind: "body",
						size: L.value,
						density: R.value,
						tone: "secondary",
						wrap: "balance",
						as: "p",
						class: "d-empty-state__body-text"
					}, {
						default: S(() => [p(y(C.bodyText), 1)]),
						_: 1
					}, 8, ["size", "density"])) : d("", !0)]),
					_: 1
				}, 8, ["class"]),
				b(e)(b(w).body) ? (_(), f("div", {
					key: 2,
					class: h(C.bodyClass)
				}, [v(r.$slots, "body")], 2)) : d("", !0)
			]),
			_: 3
		}, 8, ["class"]));
	}
});
//#endregion
export { C as default };

//# sourceMappingURL=empty-state.js.map